module.exports = __webpack_public_path__ + "static/8-62cb732fa3b28ffe06edeaa6c055c99d.jpeg";